import "../../App.css";
import LayerGroup from "ol/layer/Group";
import mainWindow, { setLayersvalue } from "./../MainWindow";
import { getLayerName } from "../../TimeLine/MainTimeLineVisible";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";

export let weatherLayerGroup = new LayerGroup({});


let receivedLayer: string = "";
let previousLayer: string = "";

type LayerMapType = Map<string, ImageLayer<ImageWMS>>;
let layerMap: LayerMapType = new Map();

export let weatherMapECMF: Map<string, LayerMapType> = new Map();
export let weatherMapICON: Map<string, LayerMapType> = new Map();

export function allWeatherMapECMWF(
  weatherLayerName: string,
  layerMap: LayerMapType
) {
  weatherMapECMF.set(weatherLayerName, layerMap);
}

export function allWeatherMapICON(
  weatherLayerName: string,
  layerMap: LayerMapType
) {
  weatherMapICON.set(weatherLayerName, layerMap);
}

export default function addWeatherLayerGroup(
  receivedWeatherLayer: ImageLayer<ImageWMS>,
  isRemove: boolean,
  layerName: string
): LayerGroup {
  if (!isRemove) {
    const layersArray = weatherLayerGroup.getLayers().getArray();
    const initialLayer=weatherLayerGroup.getLayers().getArray()[0]
    const receivedName=receivedWeatherLayer.get("name")

    if (receivedLayer !== layerName) {
      weatherLayerGroup.getLayers().clear();
    }

    // if(layersArray.length>0){
    //   weatherLayerGroup.getLayers().forEach(function (layer) {
    //     if (layer.get("name") != undefined && layer.get("name") !== receivedName) {
    //       weatherLayerGroup.getLayers().push(receivedWeatherLayer);
    //     }
    //   });
    // }else{
    //   weatherLayerGroup.getLayers().push(receivedWeatherLayer); 
    // }

    receivedWeatherLayer.getSource()?.refresh();

   const removeLoadLayers = receivedWeatherLayer.getSource()?.on('imageloadend', () => {

       const layersArrays = weatherLayerGroup.getLayers().getArray();
       weatherLayerGroup.getLayers().remove(initialLayer);
       if(layersArrays.length>2){
        
        weatherLayerGroup.getLayers().clear();
      //  weatherLayerGroup.getLayers().push(receivedWeatherLayer); 
    }
     
    });
    weatherLayerGroup.getLayers().push(receivedWeatherLayer); 
    
    setLayersvalue(layerName);
    getLayerName(layerName, true);
    receivedLayer = layerName;
    previousLayer=receivedName;;
  } else {

    const currentName=weatherLayerGroup.getLayers().getArray()[0]
    weatherLayerGroup.getLayers().remove(currentName);
    weatherLayerGroup.getLayers().clear();
    getLayerName(layerName, false);
  }

  return weatherLayerGroup;
}

export let ecmf: Map<number, number> = new Map([
  [0, 0],
  [1, 3],
  [2, 6],
  [3, 9],
  [4, 12],
  [5, 15],
  [6, 18],
  [7, 21],
  [8, 24],
  [9, 27],
  [10, 30],
  [11, 33],
  [12, 36],
  [13, 39],
  [14, 42],
  [15, 45],
  [16, 48],
  [17, 51],
  [18, 54],
  [19, 57],
  [20, 60],
  [21, 63],
  [22, 66],
  [23, 69],
  [24, 72],
  [25, 75],
  [26, 78],
  [27, 81],
  [28, 84],
  [29, 87],
  [30, 90],
  [31, 93],
  [32, 96],
  [33, 99],
  [34, 102],
  [35, 105],
  [36, 108],
  [37, 111],
  [38, 114],
  [39, 117],
  [40, 120],
  [41, 123],
  [42, 126],
  [43, 129],
  [44, 132],
  [45, 135],
  [46, 138],
  [47, 141],
  [48, 144],
  [49, 150],
  [50, 156],
  [51, 162],
  [52, 168],
  [53, 174],
  [54, 180],
  [55, 186],
  [56, 192],
  [57, 198],
  [58, 204],
  [59, 210],
  [60, 216],
  [61, 222],
  [62, 228],
  [63, 234],
  [64, 240],
]);

export let ICON: Map<number, number> = new Map([
  [0, 0],
  [1, 1],
  [2, 2],
  [3, 3],
  [4, 4],
  [5, 5],
  [6, 6],
  [7, 7],
  [8, 8],
  [9, 9],
  [10, 10],
  [11, 11],
  [12, 12],
  [13, 13],
  [14, 14],
  [15, 15],
  [16, 16],
  [17, 17],
  [18, 18],
  [19, 19],
  [20, 20],
  [21, 21],
  [22, 22],
  [23, 23],
  [24, 24],
  [25, 25],
  [26, 26],
  [27, 27],
  [28, 28],
  [29, 29],
  [30, 30],
  [31, 31],
  [32, 32],
  [33, 33],
  [34, 34],
  [35, 35],
  [36, 36],
  [37, 37],
  [38, 38],
  [39, 39],
  [40, 40],
  [41, 41],
  [42, 42],
  [43, 43],
  [44, 44],
  [45, 45],
  [46, 46],
  [47, 47],
  [48, 48],
  [49, 49],
  [50, 50],
  [51, 51],
  [52, 52],
  [53, 53],
  [54, 54],
  [55, 55],
  [56, 56],
  [57, 57],
  [58, 58],
  [59, 59],
  [60, 60],
  [61, 61],
  [62, 62],
  [63, 63],
  [64, 64],
  [65, 65],
  [66, 66],
  [67, 67],
  [68, 68],
  [69, 69],
  [70, 70],
  [71, 71],
  [72, 72],
  [73, 73],
  [74, 74],
  [75, 75],
  [76, 76],
  [77, 77],
  [78, 78],
  [79, 81],
  [80, 84],
  [81, 87],
  [82, 90],
  [83, 93],
  [84, 96],
  [85, 99],
  [86, 102], 
[87, 105], 
[88, 108], 
[89, 111], 
[90, 114], 
[91, 117], 
[92, 120], 
[93, 123], 
[94, 126], 
[95, 129], 
[96, 132], 
[97, 135], 
[98, 138], 
[99, 141], 
[100, 144], 
[101, 147], 
[102, 150], 
[103, 153], 
[104, 156], 
[105, 159], 
[106, 162], 
[107, 165], 
[108, 168], 
[109, 171], 
[110, 174], 
[111, 177], 
[112, 180]
]);
